import startCase from 'lodash/startCase';
import moment from 'moment-timezone';
import {useSelector} from 'react-redux';
import {useCartEndpoints} from '~/common/checkout/hooks/useCartEndpoints';
import {getEventId} from '~/common/fabric/reducers/eviteEvent/selectors';
import {selectUserEmail} from '~/common/fabric/User/reducers/user';
import {pluralize} from '~/common/utils';
import {centsToDollarDisplay} from '~/common/utils/payment_utils';
import {Typography} from '~library/atoms/Typography';

import './OrderDetails.sass';

export const OrderDetails = () => {
  const eventId = useSelector(getEventId);
  const email = useSelector(selectUserEmail);
  const {checkoutData} = useCartEndpoints({eventId, skipCart: true, skipPackages: true});
  const {
    guestsAdded = 0,
    invoiceLineItem = '',
    paymentMethodDescription = '',
    paymentMethod,
    promotions = {},
    total = 0,
  } = checkoutData;
  const totalDisplay = centsToDollarDisplay(total, true, false);
  const fabricGreetingCard = useSelector((state) => state.guests?.fabricGreetingCard);

  // This is a safe check because in all current usages of <OrderDetails />,
  // we only render it if checkoutData is truthy
  if (!checkoutData) return null;

  return (
    <div className="payments-panel__order-summary">
      <h3 className="order-summary__heading font_20">Order Summary</h3>
      <div className="order-summary__grid">
        <div className="order-summary__field">
          <Typography className="premium-frp__label order-summary__label label_14" variant="label2">
            Email
          </Typography>
          <span className="font_18" data-qa-value="buyer">
            {email}
          </span>
        </div>
        <div className="order-summary__field">
          <Typography className="premium-frp__label order-summary__label label_14" variant="label2">
            Order Date
          </Typography>
          <span className="font_18" data-qa-value="purchase-date">
            {moment().format('ll')}
          </span>
        </div>
        {invoiceLineItem && (
          <div className="order-summary__field full-width">
            <Typography
              className="premium-frp__label order-summary__label label_14"
              variant="label2"
            >
              Order
            </Typography>
            <span className="font_18" data-qa-value="table-product" id="done-table-product">
              {invoiceLineItem}
            </span>
          </div>
        )}
        {guestsAdded > 0 && (
          <div className="order-summary__field full-width">
            <Typography
              className="premium-frp__label order-summary__label label_14"
              variant="label2"
            >
              Sent to
            </Typography>
            <span className="font_18" data-qa-value="sent-to" id="done-table-product">
              {pluralize(fabricGreetingCard ? 'recipient' : 'guest', guestsAdded)}
            </span>
          </div>
        )}
        {Object.keys(promotions) > 0 && (
          <div className="order-summary__field">
            <Typography
              className="premium-frp__label order-summary__label label_14"
              variant="label2"
            >
              Promo Code
            </Typography>
            <span className="font_18" data-qa-value="promo-codes" id="done-table-product">
              {promotions}
            </span>
          </div>
        )}
        {paymentMethodDescription && (
          <div className="order-summary__field">
            <Typography
              className="premium-frp__label order-summary__label label_14"
              variant="label2"
            >
              Payment Method
            </Typography>
            <span className="font_18" data-qa-id="billed" id="done-table-product">
              {paymentMethodDescription || startCase(paymentMethod)}
            </span>
          </div>
        )}
        <div className="order-summary__field">
          <Typography className="premium-frp__label order-summary__label label_14" variant="label2">
            Total
          </Typography>
          <span
            className="font_18"
            data-qa-id="done-table-total"
            data-qa-value="total"
            id="done-table-total"
          >
            {totalDisplay}
          </span>
        </div>
      </div>
    </div>
  );
};
